import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
// import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { FileLink } from 'containers/misc'
import { requestDownload } from 'redux/modules/app'
import fetchFile from 'helpers/fetchFile'

@connect(
  ({ app, auth }) => ({
    user: auth.user,
    requestedSrc: app.download.requestedSrc,
    requestId: app.download.requestId
  }),
  {
    requestDownload
  }
)
class FileDownload extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    requestedSrc: PropTypes.string,
    requestDownload: PropTypes.func,
    requestId: PropTypes.any,
    id: PropTypes.any
  }

  componentWillReceiveProps = nextProps => {
    const { id, user } = this.props

    if (id === nextProps.requestId && nextProps.requestedSrc) {
      fetchFile(nextProps.requestedSrc, user)
    }
  }

  shouldComponentUpdate = nextProps => {
    if (nextProps.id === nextProps.requestId) {
      return true
    }
    return false
  }

  componentWillUnmount = () => {
    this.props.requestDownload({
      requestId: null,
      requestedSrc: null
    })
  }

  render() {
    const { id, requestedSrc } = this.props

    if (!id || !requestedSrc) {
      return null
    }

    return (
      <div className="text--center base-margin--top">
        <FormattedMessage
          id="label.if_your_download_doesnt_start"
          defaultMessage="If your download doesn't start automatically please click this"
        />{' '}
        <FileLink src={requestedSrc} intlKey="label.link" label="link" />.
      </div>
    )
  }
}

export default FileDownload
